import { AxiosResponse, InternalAxiosRequestConfig } from 'axios'
import Storage from '../../Storage'

export const request = (
  config: InternalAxiosRequestConfig
): InternalAxiosRequestConfig => {
  const { getAuthTokens } = Storage()
  const { accessToken, refreshToken } = getAuthTokens()

  if (config.headers && accessToken && refreshToken) {
    config.headers.Authorization = `Bearer ${accessToken}`
    config.headers['Stack-Refresh-Token'] = `Bearer ${refreshToken}`
  }

  return config
}

export const response = (response: AxiosResponse): AxiosResponse => {
  const { setAuthTokens } = Storage()
  const { headers } = response

  if (headers['Stack-Token'] && headers['Stack-Refresh-Token']) {
    setAuthTokens({
      accessToken: headers['Stack-Token'],
      refreshToken: headers['Stack-Refresh-Token']
    })
  }

  return response
}
